import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const QUERY_PARAM_LANGUAGE_MAP: Record<string, string> = {
    it: 'it',
    gb: 'en',
    'us/ca': 'en-US',
    fr: 'fr',
    es: 'es',
    hu: 'hu',
    ro: 'ro',
    de: 'de',
};

const LANGUAGE_COOKIE_MAP: Record<string, string> = {
    it: 'it',
    en: 'gb',
    'en-US': 'us/ca',
    fr: 'fr',
    es: 'es',
    hu: 'hu',
    ro: 'ro',
    de: 'de',
};

export function getDocumentaleLanguagePath(language: string) {
    if (language === 'en-US') {
        return 'en-US';
    }

    if (language === 'en') {
        return 'en-UK';
    }

    return `${language}-${language.toUpperCase()}`;
}

function pushLangToDataLayer(language?: string, source: 'site_open' | 'language_change' = 'language_change') {
    const lang = language ? LANGUAGE_COOKIE_MAP[language] : undefined;

    if (!lang || typeof window === 'undefined') {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'changeLang',
        lang,
        language,
        source,
    });
}

let isInitialLanguageTracked = false;

i18n.on('languageChanged', (language) => {
    if (!isInitialLanguageTracked) {
        return;
    }

    pushLangToDataLayer(language, 'language_change');
});

i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'en',
        debug: true,
        supportedLngs: ['de', 'en', 'en-US', 'es', 'fr', 'hu', 'it', 'ro'],
        nonExplicitSupportedLngs: true,
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            lookupQuerystring: 'lang',
            convertDetectedLanguage: (lng: string) => QUERY_PARAM_LANGUAGE_MAP[decodeURIComponent(lng)] ?? lng,
        },
    })
    .then(() => {
        pushLangToDataLayer(i18n.resolvedLanguage ?? i18n.language, 'site_open');
        isInitialLanguageTracked = true;
    });

console.log('Detected language:', i18n.language);
console.log('Browser language:', navigator.language);

export default i18n;
